import { createContext, useContext, useState } from 'react';

const GlobalDataContext = createContext();

export const GlobalDataProvider = ({ children }) => {
  const [globalData, setGlobalData] = useState(null);

  return (
    <GlobalDataContext.Provider value={{ globalData, setGlobalData }}>
      {children}
    </GlobalDataContext.Provider>
  );
};

export const useGlobalData = () => useContext(GlobalDataContext);
